// frontend/src/SablonFormu.js
import React, { useState, useEffect } from 'react';
import { Form, Button, Row, Col, InputGroup } from 'react-bootstrap';
import api from './api';

function SablonFormu({ mevcutSablon, onFormSubmit, onIptal }) {
  const [ad, setAd] = useState('');
  const [kategoriId, setKategoriId] = useState('');
  const [icerikler, setIcerikler] = useState([{ besin_id: '', miktar: '', olcu_birimi_id: '' }]);
  const [besinListesi, setBesinListesi] = useState([]);
  const [olcuBirimiListesi, setOlcuBirimiListesi] = useState([]);
  const [kategoriListesi, setKategoriListesi] = useState([]);

  useEffect(() => {
    api.get('/diyetisyen/besinler').then(res => setBesinListesi(res.data || []));
    api.get('/diyetisyen/olcu-birimleri').then(res => setOlcuBirimiListesi(res.data || []));
    api.get('/diyetisyen/kategoriler').then(res => setKategoriListesi(res.data || []));
  }, []);

  useEffect(() => {
    if (mevcutSablon) {
      setAd(mevcutSablon.ad || '');
      setKategoriId(mevcutSablon.kategori ? mevcutSablon.kategori.id : '');
      const formatliIcerikler = mevcutSablon.icerikler.map(ic => ({
        besin_id: ic.besin.id, miktar: ic.miktar, olcu_birimi_id: ic.olcu_birimi.id
      }));
      setIcerikler(formatliIcerikler.length > 0 ? formatliIcerikler : [{ besin_id: '', miktar: '', olcu_birimi_id: '' }]);
    }
  }, [mevcutSablon]);

  const handleIcerikDegistir = (index, event) => {
    const yeniIcerikler = [...icerikler];
    yeniIcerikler[index][event.target.name] = event.target.value;
    setIcerikler(yeniIcerikler);
  };
  const handleIcerikEkle = () => setIcerikler([...icerikler, { besin_id: '', miktar: '', olcu_birimi_id: '' }]);
  const handleIcerikSil = (index) => {
    const yeniIcerikler = [...icerikler];
    yeniIcerikler.splice(index, 1);
    setIcerikler(yeniIcerikler);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    onFormSubmit({ ad, kategori_id: kategoriId || null, icerikler });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group as={Row} className="mb-3">
        <Form.Label column sm={2}>Şablon Adı</Form.Label>
        <Col sm={10}><Form.Control type="text" value={ad} onChange={(e) => setAd(e.target.value)} required /></Col>
      </Form.Group>
      <Form.Group as={Row} className="mb-3">
        <Form.Label column sm={2}>Kategori</Form.Label>
        <Col sm={10}>
          <Form.Select value={kategoriId} onChange={(e) => setKategoriId(e.target.value)}>
            <option value="">Kategori Seçin (isteğe bağlı)</option>
            {kategoriListesi.map(k => <option key={k.id} value={k.id}>{k.ad}</option>)}
          </Form.Select>
        </Col>
      </Form.Group>
      <hr/>
      <h5>İçerikler</h5>
      {icerikler.map((icerik, index) => (
        <InputGroup key={index} className="mb-2">
          <Form.Control type="number" name="miktar" placeholder="Miktar" value={icerik.miktar} onChange={(e) => handleIcerikDegistir(index, e)} required style={{ flex: '0.5' }} />
          <Form.Select name="olcu_birimi_id" value={icerik.olcu_birimi_id} onChange={(e) => handleIcerikDegistir(index, e)} required style={{ flex: '1' }}>
            <option value="">Ölçü</option>
            {olcuBirimiListesi.map(b => <option key={b.id} value={b.id}>{b.ad}</option>)}
          </Form.Select>
          <Form.Select name="besin_id" value={icerik.besin_id} onChange={(e) => handleIcerikDegistir(index, e)} required style={{ flex: '2' }}>
            <option value="">Besin</option>
            {besinListesi.map(b => <option key={b.id} value={b.id}>{b.ad}</option>)}
          </Form.Select>
          <Button variant="outline-danger" onClick={() => handleIcerikSil(index)}>X</Button>
        </InputGroup>
      ))}
      <Button variant="outline-secondary" size="sm" onClick={handleIcerikEkle}>+ İçerik Ekle</Button>
      <div className="d-flex justify-content-end mt-3">
        <Button variant="secondary" onClick={onIptal} className="me-2">İptal</Button>
        <Button type="submit" variant="primary">{mevcutSablon ? 'Güncelle' : 'Kaydet'}</Button>
      </div>
    </Form>
  );
}
export default SablonFormu;